@if (!loading) {
  <mat-sidenav-container class="sidenav-container">
    <mat-sidenav #drawer class="sidenav" fixedInViewport [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
      [mode]="'over'" [opened]="false">
      <mat-toolbar color="primary" [class.staging]="isStaging()">
        <img src="assets/logo-600.webp" height="40px">
      </mat-toolbar>
      <mat-nav-list>
        @if (auth.activeAccount() && (auth.isAdmin() || auth.isConsultant())) {
        <span style="margin-left: 1rem;margin-bottom: 1rem;">{{ auth.activeAccount()?.name }}</span>
        <!-- <span style="margin: 0 1rem;"></span> -->
        <a mat-list-item routerLink="/orders" routerLinkActive="active-link" (click)="drawer.close()">Projekter</a>
        <a mat-list-item routerLink="/pivot" routerLinkActive="active-link" (click)="drawer.close()">Rapport</a>
        <a mat-list-item routerLink="/consultant-summary" routerLinkActive="active-link" (click)="drawer.close()">Totaler</a>
        @if (auth.hasDashboardAccess()) {
          <a mat-list-item routerLink="/dashboard" routerLinkActive="active-link" (click)="drawer.close()">Dashboard</a>
        }
        <a mat-list-item routerLink="/invoices" routerLinkActive="active-link" (click)="drawer.close()">Fakturaer</a>
        <a mat-list-item routerLink="/fee-basis" routerLinkActive="active-link" (click)="drawer.close()">Honorargrundlag</a>
        @if (auth.isAdmin()) {
        <a mat-list-item routerLink="/admin" routerLinkActive="active-link" (click)="drawer.close()">Administration</a>
        }
        }
        @if (auth.activeAccount()) {
        <a mat-list-item (click)="logout(); drawer.close()">Log ud</a>
        }
      </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content>
      <mat-toolbar color="primary" [class.staging]="isStaging()">
        <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()">
          <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
        </button>
        @if (!drawer.opened) {
        <img src="assets/logo-600.webp" height="40px">
        }
      </mat-toolbar>
      @if (!isIframe) {
      <router-outlet></router-outlet>
      }
    </mat-sidenav-content>
  </mat-sidenav-container>
}
